import * as React from 'react'

import { styled } from '../../../common/ui'
import { theme } from '../theme'

// https://codepen.io/Paolo-Duzioni/pen/ZoRabJ
export class LoadingMask extends React.Component<
  { isVisible: boolean; title?: string },
  {}
> {
  render() {
    const { isVisible, title } = this.props
    return (
      isVisible && (
        <Mask>
          <Spinner />
          <Title>{title}</Title>
        </Mask>
      )
    )
  }
}

const Spinner = styled.div`
  background-color: #fff;
  width: 100px;
  height: 100px;
  animation: flip 1.2s ease infinite;

  @keyframes flip {
    0% {
      transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    }
    50% {
      transform: perspective(120px) rotateX(-180deg) rotateY(0deg);
    }
    100% {
      transform: perspective(120px) rotateX(-180deg) rotateY(-180deg);
    }
  }
`

// const Loader = styled.div`
//   border: 8px solid #f3f3f3; /* Light grey */
//   border-top: 8px solid ${theme.colors.blue}; /* Blue */
//   border-radius: 50%;
//   width: 30px;
//   height: 30px;
//   animation: spin 1s linear infinite;

//   @keyframes spin {
//     0% {
//       transform: rotate(0deg);
//     }
//     100% {
//       transform: rotate(360deg);
//     }
//   }
// `
const Title = styled.div`
  text-align: center;
  color: #fff;
  padding: 32px 0;
  font-size: 17px;
  font-weight: bold;
  text-transform: uppercase;
  font-family: ${theme.fonts.text};
`
const Mask = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.83);
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 333;
`
